import { checkIfOfferHasTimeOfUseProduct } from '../../shared/helpers/misc';
import { Offer } from '../../shared/types';

export const touExperimentFeatureToggleKey = '699416|energy-flow-timeofuse';

/** 50/50 split on showing the call-support widget. Variant `ON` shows it, everything else (`OFF`) is control. */
export const callSupportExperimentFeatureToggleKey = 'exp-n-607-show-phone-number';
export const callSupportExperimentVariant = 'ON';

/**
 * Default contract-type selection on the offer step. Variant `ON` pre-selects the first offer
 * returned by the backend; everything else (`OFF`) is the control, leaving the user to choose.
 */
export const defaultContractTypeExperimentFeatureToggleKey = 'exp-n-611-product-card-default-open';

export const defaultContractTypeExperimentVariant = 'ON';

export const touExperimentProductFilter = (offer: Offer, variant: string | null) => {
  const isTimeOfUse = checkIfOfferHasTimeOfUseProduct(offer);
  const hasVariableDiscount = offer?.discountType?.includes?.('variable');

  switch (variant) {
    case 'A':
      return !isTimeOfUse;

    case 'B':
      return !(isTimeOfUse || hasVariableDiscount);

    case 'C':
      return !hasVariableDiscount;

    default:
      return true;
  }
};
